// import { mapGetters, mapActions } from 'vuex';

export default {
  // data: () => ({
  //   trackingTimer: null
  // }),

  // computed: {
  //   ...mapGetters([
  //     'trackingData'
  //   ])
  // },

  // mounted() {
  //   this.trackingTimer = setInterval(() => {
  //     this.handleTrackingData();
  //   }, 1000);
  // },

  methods: {
    // ...mapActions([
    //   'addTrackingData',
    //   'resetTrackingData'
    // ]),

    // handleTrackingData(data = null) {
    //   if (!this.isTrackingReady()) {
    //     if (data !== null) {
    //       this.addTrackingData(data);
    //     }

    //     return;
    //   }

    //   [...this.trackingData, data]
    //     .filter(d => !!d && !!d.event)
    //     .forEach(t => {
    //       if (t.event === 'nakamiTransition' && !t.pageProduct) {
    //         t.pageProduct = this.getPageProduct();
    //       }

    //       window.dataLayer.push(t);
    //     });

    //   this.resetTrackingData();

    //   if (this.trackingTimer) {
    //     clearInterval(this.trackingTimer);
    //     this.trackingTimer = null;
    //   }
    // },

    trackEvent(name, properties) {
      if (!window.DY) {
        return;
      }

      return new Promise((resolve) => {
        let trackData = {
          name,
          properties
        };

        window.DY.API('event', trackData);
        resolve('OK');
      });
    },

    trackPageView(context, url) {
      if (!window.DY) {
        return;
      }

      return new Promise((resolve) => {
        let trackData = {
          context,
          url,
          countAsPageview: true
        };

        window.DY.API('spa', trackData);
        resolve('OK');
      });
    },

    isTrackingReady() {
      if (!window.dataLayer || !window.dataLayer.length) {
        return false;
      }

      return true;
    },

    getPageProduct() {
      if (!this.isTrackingReady()) {
        return null;
      }

      const pageEntry = window.dataLayer.find(d => !!d.pageProduct);

      return pageEntry
        ? pageEntry.pageProduct
        : '';
    },

    handleTrackingData(data) {
      if (!this.isTrackingReady()) {
        return;
      }

      window.dataLayer.push(data);
    },

    triggerTransitionEvent(moduleType, moduleStepIndex = 0, moduleStep = '', moduleSubStepIndex = null, moduleSubStep = '', productChoice = '', pageTopic = null, partner = null) {
      if (this.config.theme !== 'vkb' && this.config.theme !== 'fsoel' && this.config.theme !== 'vkb_bc') {
        return;
      }

      const trackingData = {
        event: 'nakamiTransition',
        nakamiModuleType: moduleType,
        pageProduct: this.getPageProduct(),
        moduleStep: 'parameterKonfigurieren'
      };

      if (moduleStepIndex) {
        trackingData.moduleStepIndex = moduleStepIndex < 10
          ? `0${ moduleStepIndex }`
          : `${ moduleStepIndex }`;
      }

      if (moduleStep) {
        trackingData.moduleStep = moduleStep;
      }

      if (moduleSubStepIndex === -1) {
        trackingData.moduleSubStepIndex = '-';
      } else if (moduleSubStepIndex !== null) {
        trackingData.moduleSubStepIndex = moduleSubStepIndex < 10
          ? `0${ moduleSubStepIndex }`
          : `${ moduleSubStepIndex }`;
      }

      if (moduleSubStep) {
        trackingData.moduleSubStep = moduleSubStep;
      }

      if (productChoice) {
        trackingData.productChoice = productChoice;
      }

      if (pageTopic) {
        trackingData.pageTopic = pageTopic;
      }

      if (partner) {
        trackingData.partner = partner;
      }

      this.handleTrackingData(trackingData);
    },

    triggerActionEvent(action = '', moduleType = null, force = false) {
      if (this.config.theme !== 'vkb' && this.config.theme !== 'fsoel' && !force) {
        return;
      }

      const params = {
        event: 'nakamiEvent',
        nakamiEventAction: action,
      };

      if (moduleType) {
        params.nakamiModuleType = moduleType;
      }

      this.handleTrackingData(params);
    },

    triggerUpdateEvent(productChoice = '') {
      if (this.config.theme !== 'vkb' && this.config.theme !== 'fsoel') {
        return;
      }

      const trackingData = {
        event: 'nakamiUpdate',
      };

      if (productChoice) {
        trackingData.productChoice = productChoice;
      }

      this.handleTrackingData(trackingData);
    },

    triggerValidationEvent(vForm, trackingKeys = [], errorMessages = [], fieldNames = null) {
      if (this.config.theme !== 'vkb' && this.config.theme !== 'fsoel') {
        return;
      }

      const validFields = [];
      const invalidFields = [];

      trackingKeys
        .forEach(k => {
          if (!vForm || !vForm[k]) {
            return validFields.push(k);
          }

          const validity = vForm[k];
          const error_key = Object.keys(validity.$params)
            .find(k => validity[k] === false);

          const fieldName = fieldNames
            ? fieldNames[k]
            : k;

          if (!error_key) {
            validFields.push(fieldName);
          } else {
            invalidFields.push({
              name: fieldName,
              error: errorMessages[k]
                ? errorMessages[k][error_key]
                : ''
            });
          }
        });

      const inputFieldsOk = validFields.join(', ');
      const inputFieldsError = invalidFields
        .map(f => `${ f.name }(${ f.error })`)
        .join(', ');

      this.handleTrackingData({
        event: 'nakamiValidation',
        inputFieldsOk,
        inputFieldsError
      });
    }
  }
};


// WEBPACK FOOTER //
// ./src/mixins/trackingHandler.js